import * as angular from 'angular';
import { StateService, Transition } from '@uirouter/angularjs';

import { Application, ComponentDefinition } from '../../models';
import { IApplicationService, IStoreService, ILoggerService, INavigationHistoryService } from '../../services';
import { StoreElement } from '../../stateManagement';

class ReloadCacheController implements angular.IComponentController, angular.IOnDestroy {
    isLoading: boolean;
    loadingMessage: string = 'Reloading cache';

    // Special object injected by UI-Router used for redirection to previpous state
    readonly $transition$: Transition;

    private _unsubscribe: () => void;

    static $inject = ['$state', 'applicationService', 'loggerService', 'storeService'];

    constructor(
        private _$state: StateService,
        private _applicationService: IApplicationService,
        private _loggerService: ILoggerService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        let application: Application;
        this.isLoading = true;
        this._unsubscribe = this._storeService.register(store => {
            application = store.application.value;
        }, [StoreElement.Application]);
        if (application) {
            const applicationDispatcher = this._storeService.dispatchers().application;

            this._applicationService
                .reloadCache()
                .then(() => {
                    this._loggerService.logSuccess('Sucessfully refreshed');
                    this.loadingMessage = 'Cleaning redux store';
                    return applicationDispatcher.disconnect();
                })
                .then(() => applicationDispatcher.connect(application))
                .then(() => {
                    if(this.$transition$){
                        this._$state.go(this.$transition$.from().name, this.$transition$.params('from'));
                    }
                })
                .finally(() => this.isLoading = false);
        }
    }

    $onDestroy(): void {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }
}

export const reloadCache: ComponentDefinition = {
    componentId: 'wtReloadCache',
    controller: ReloadCacheController,
    template: require('./reloadCache.component.html'),
    controllerAs: 'vm',
    bindings: {
        $transition$: '<'
    }
};
